import { Typography } from '@mui/material';
import { BuyerMethod, type ClientGroup } from '../../types';

export const sentText =
  'Note that a signed Buyer Agreement will be required in order to send the offer to a listing agent. You’ll have the opportunity to send more documents once the Offer is created.';
export const notSentText =
  'Note that a signed Buyer Agreement will be required in order to send the offer to a listing agent';

const AGREEMENT_STATUS_MAP: Record<
  NonNullable<ClientGroup['agreementStatus']>,
  string
> = {
  created: sentText,
  completed:
    'You’ll have the opportunity to send more documents once the Offer is created',
  declined: notSentText,
  delivered: sentText,
  failed: notSentText,
  notFinalized: sentText,
  partiallySigned: sentText,
  sending: sentText,
  sent: sentText,
  voided: notSentText,
};

export const HelperText = ({
  buyer,
  buyerMethod,
  loading,
}: {
  buyer: ClientGroup | undefined | null;
  buyerMethod?: BuyerMethod;
  loading?: boolean;
}) => {
  if (
    !buyer ||
    buyerMethod !== BuyerMethod.existingBuyer ||
    !buyer.agreementStatus ||
    loading
  ) {
    return (
      <Typography
        variant="body2"
        sx={{ color: loading ? 'text.disabled' : 'text.secondary' }}
      >
        {notSentText}
      </Typography>
    );
  }

  return (
    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
      {AGREEMENT_STATUS_MAP[buyer.agreementStatus]}
    </Typography>
  );
};
